import { createActions, handleActions } from 'redux-actions'
import _ from 'lodash'
import fetch from 'isomorphic-fetch'

const { REACT_APP_API_HOST } = process.env

export const timelineRoute = {
  domain: REACT_APP_API_HOST,
  path: '/api/timeline?valid=true',
}

const start = 1860
const end = 2000

export const initialState = {
  min: start,
  max: end,
  current: start,
  phases: {
    1: {
      start,
      end: 1909,
      map: 1866,
    },
    2: {
      start: 1910,
      end: 1947,
      map: 1911,
    },
    3: {
      start: 1949,
      end: end,
      map: 1949,
    },
  },
  results: {},
  selectedTopicID: null,
  showPeriodLayer: false,
  isFetching: false,
  lastUpdated: null,
}

// Actions
export const REQUEST_TIMELINE = 'REQUEST_TIMELINE'
export const RECEIVE_TIMELINE = 'RECEIVE_TIMELINE'
export const CHANGE_YEAR = 'CHANGE_YEAR'
export const INCREMENT_YEAR = 'INCREMENT_YEAR'
export const SELECT_TOPIC = 'SELECT_TOPIC'
export const DESELECT_TOPIC = 'DESELECT_TOPIC'
export const SHOW_PERIOD_LAYER = 'SHOW_PERIOD_LAYER'
export const HIDE_PERIOD_LAYER = 'HIDE_PERIOD_LAYER'
export const TOGGLE_PERIOD_LAYER = 'TOGGLE_PERIOD_LAYER'

// Reducer
const reducer = handleActions(
  {
    [REQUEST_TIMELINE]: state => ({ ...state, isFetching: true }),
    [RECEIVE_TIMELINE]: (state, { payload: { timeline, receivedAt } }) => ({
      ...state,
      isFetching: false,
      results: _.keyBy(timeline, 'id'),
      lastUpdated: receivedAt,
    }),
    [CHANGE_YEAR]: (state, { payload: year }) => {
      const { selectedTopicID, results: topics } = state
      const topic = selectedTopicID && topics[selectedTopicID]
      const deselectTopic = topic && (year < topic.start || year > topic.end)

      return {
        ...state,
        current: year,
        selectedTopicID: deselectTopic ? null : selectedTopicID,
      }
    },
    [SELECT_TOPIC]: (state, { payload: { id } }) => {
      if (id !== state.selectedTopicID) {
        const { start, end } = state.results[id]
        const { current } = state
        return {
          ...state,
          selectedTopicID: id,
          // Set year to topic start
          current: current < start || current > end ? start : current,
        }
      }
      return { ...state, selectedTopicID: null }
    },
    [DESELECT_TOPIC]: state => {
      const prev = state.selectedTopicID
      return {
        ...state,
        selectedTopicID: null,
        current: prev ? state.results[prev].start : state.current,
      }
    },
    [INCREMENT_YEAR]: state => ({
      ...state,
      current: Math.max((state.current + 1) % (end + 1), start),
    }),
    [SHOW_PERIOD_LAYER]: state => ({ ...state, showPeriodLayer: true }),
    [HIDE_PERIOD_LAYER]: state => ({ ...state, showPeriodLayer: false }),
    [TOGGLE_PERIOD_LAYER]: state => ({
      ...state,
      showPeriodLayer: !state.showPeriodLayer,
    }),
  },
  initialState
)
export default reducer

// Action creator
export const {
  receiveTimeline,
  requestTimeline,
  changeYear,
  selectTopic,
  deselectTopic,
  incrementYear,
  showPeriodLayer,
  hidePeriodLayer,
  togglePeriodLayer,
} = createActions(
  {
    [RECEIVE_TIMELINE]: timeline => ({
      timeline,
      receivedAt: Date.now(),
    }),
  },
  REQUEST_TIMELINE,
  CHANGE_YEAR,
  SELECT_TOPIC,
  DESELECT_TOPIC,
  INCREMENT_YEAR,
  SHOW_PERIOD_LAYER,
  HIDE_PERIOD_LAYER,
  TOGGLE_PERIOD_LAYER
)

export function fetchTimeline(
  path = `${timelineRoute.domain}${timelineRoute.path}`
) {
  return dispatch => {
    dispatch(requestTimeline())
    return fetch(path)
      .then(
        response => response.json(),
        error => console.log('An error occured', error)
      )
      .then(json => dispatch(receiveTimeline(json)))
  }
}
